import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiOrgPositionsService {

  constructor(
    private apiBasic: ApiBasicService
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   * 
   * @param params 
   * @returns 
   */
  getList(params: any): Observable<Res> {
    return this.apiBasic.getList(params, 'orgs_positions');
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('orgs_positions', params);
  }

  /**
  * 
  * @param id string
  * @returns Observable<Res>
  */
  edit(id: string = ''): Observable<Res> {

    return this.apiBasic.edit('orgs_positions', id);
  }

  /**
* 
* @param params any
* @returns Observable<Res>
*/
  update(params: any): Observable<Res> {

    return this.apiBasic.update('orgs_positions', params);
  }


  /**
   * 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('orgs_positions', params);
  }
}


